var router = require('pjax').Router;
var index = require('./index.js');
var report = require('./report.js');

router.get('dashboard', index);
router.get('report/:any', index);
router.get('report/:any', report);
